import Marquee from "react-fast-marquee";

const brands = [
  { name: "Nykaa", italic: false },
  { name: "Sephora", italic: true },
  { name: "YSL Beauty", italic: false },
  { name: "Adidas", italic: true },
  { name: "Huda Beauty", italic: false },
  { name: "M.A.C Cosmetics", italic: true },
  { name: "Kiko Beauty", italic: false },
];

export const BrandsMarquee = () => {
  return (
    <section
      id="brands"
      className="relative border-t hairline py-24 md:py-32 overflow-hidden"
      data-testid="brands-section"
    >
      <div className="grid grid-cols-12 px-6 md:px-10 lg:px-14 mb-14">
        <div className="col-span-12 md:col-span-3 label">03 — Legacy</div>
        <div className="col-span-12 md:col-span-9 font-serif text-3xl md:text-5xl italic text-ink/85 mt-4 md:mt-0">
          Studios &amp; houses she has shaped campaigns for.
        </div>
      </div>

      <Marquee gradient={false} speed={38} pauseOnHover={true}>
        {brands.map((b, i) => (
          <span key={`${b.name}-${i}`} className="flex items-center">
            <span
              className={`marquee-item ${b.italic ? "italic" : ""}`}
              data-testid={`brand-name-${i}`}
            >
              {b.name}
            </span>
            <span className="marquee-dot">·</span>
          </span>
        ))}
      </Marquee>

      <div className="grid grid-cols-12 px-6 md:px-10 lg:px-14 mt-14">
        <p className="col-span-12 md:col-span-6 md:col-start-4 font-sans text-mute text-sm md:text-base leading-relaxed">
          Extensive experience across global luxury beauty and lifestyle —
          exposure that sharpened her instinct for luxury marketing, consumer
          psychology, and high-impact digital activations.
        </p>
      </div>
    </section>
  );
};

export default BrandsMarquee;
